import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import playSound from "@/sound";
import { correctSound, incorrectSound, blockTouch, sleep } from "@stores/vars";
import anime from "animejs/lib/anime.es.js";

const Wrap = styled.div`
  position: relative;
  height: 1200px;
  z-index: 0;
  opacity: 0;
`;

const Card = styled.div`
  position: absolute;
  width: 895px;
  height: 535px;
  left: 50%;
  top: 225px;
  transform: translateX(-50%);
  background-color: #fff;
  border-radius: 50px;
  box-shadow: 2px 2px 0px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  > img {
    width: auto;
    height: 100%;
  }
`;

const Speaker = styled.button`
  position: absolute;
  width: 233px;
  height: 233px;
  top: 244px;
  right: 220px;
  border-radius: 50%;
  background: url(${require("@assets/img/icon_speaker.png")}) no-repeat;
  box-shadow: 2px 2px 0px 4px rgba(0, 0, 0, 0.1);
`;

const ButtonWrap = styled.div`
  position: absolute;
  left: 50%;
  bottom: 75px;
  transform: translateX(-50%);
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50px;
  padding: 30px 60px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
  &::before {
    content: "";
    position: absolute;
    width: 100px;
    height: 105px;
    bottom: 214px;
    left: -50px;
    background: url(${require("@assets/img/icon_q.png")}) no-repeat;
    background-size: 100%;
  }
  &::after {
    content: "";
    position: absolute;
    width: 99px;
    height: 108px;
    bottom: 180px;
    right: -50px;
    background: url(${require("@assets/img/icon_q2.png")}) no-repeat;
    background-size: 100%;
  }
`;

const OXButton = styled.button`
  width: 210px;
  height: 210px;
  border-radius: 40px;
  border: 15px solid #fff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  &:first-child {
    margin-right: 30px;
    display: block;
    background-color: #2ebdac;
  }
  &:last-child {
    margin-left: 30px;
    display: block;
    background-color: #ffb400;
  }
`;
const FeedBack = styled.div`
  position: absolute;
  left: 50%;
  top: 330px;
  margin-left: -166px;
  display: none;
  z-index: 10;
  &.answer-X {
    width: 332px;
    height: 332px;
    background: url(${require("@assets/img/activity_answer_x.png")}) no-repeat;
  }
  &.answer-O {
    width: 332px;
    height: 332px;
    background: url(${require("@assets/img/activity_answer_o.png")}) no-repeat;
  }
`;

const ActivityType1 = ({ data, onSuccess }) => {
  const spkRef = useRef(null);
  const btnWrapRef = useRef(null);
  const onSoundPlay = () => {
    const soundUrl = data.sound;
    playSound.word(soundUrl);
    anime({
      targets: spkRef.current,
      scale: [0.5, 1],
      opacity: [0, 1],
    });
  };

  const correct = async () => {
    // 정답 이펙트 사운드
    playSound.effect(correctSound);
    // 정답 이펙트 이미지
    const feedback = document.querySelector(".answer-O");
    feedback.style.display = "block";
    // 정답 이펙트 모션
    anime({
      targets: feedback,
      scale: [0, 1],
      opacity: [0, 1],
    });
    await sleep(2000);
    feedback.style.display = "none";
    // 정답은 한번ㄷ ㅓ 읽어줌
    await sleep(500);
    // blockTouch(false);
    onSuccess();
  };

  const incorrect = async () => {
    playSound.effect(incorrectSound);
    // 정답 이펙트 이미지
    const feedback = document.querySelector(".answer-X");
    feedback.style.display = "block";
    // 정답 이펙트 모션
    anime({
      targets: feedback,
      scale: [0, 1],
      opacity: [0, 1],
    });
    await sleep(1000);
    feedback.style.display = "none";
    blockTouch(false);
  };

  const onClickO = async () => {
    blockTouch();
    const { answer } = data;
    answer.O === true ? correct() : incorrect();
  };

  const onClickX = async () => {
    blockTouch();
    const { answer } = data;
    answer.X === true ? correct() : incorrect();
  };

  useEffect(() => {
    spkRef.current.style.pointerEvents = "none";
    btnWrapRef.current.style.pointerEvents = "none";
    btnWrapRef.current.style.opacity = 0.5;
    anime({
      targets: document.querySelector(".t2"),
      translateY: [-100, 0],
      opacity: [0, 1],
      easing: "easeOutBack",
      durtaion: 200,
    });

    playSound
      .word(require("@data/assets/_static/sounds/activity1.mp3"))
      .then(() => {
        onSoundPlay();
        anime({
          targets: btnWrapRef.current,
          opacity: 1,
          easing: "linear",
          durtaion: 200,
        });
        btnWrapRef.current.style.pointerEvents = "";
        spkRef.current.style.pointerEvents = "";
      });

    return () => {
      playSound.wordStop();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Wrap className="t2">
      <Card>
        <img src={data.img} alt="" />
      </Card>
      <Speaker type="button" onClick={onSoundPlay} ref={spkRef} />
      <ButtonWrap ref={btnWrapRef}>
        <OXButton type="button" onClick={onClickO}>
          <img src={require("@assets/img/icon_answer_o.png")} alt="" />
        </OXButton>
        <OXButton type="button" onClick={onClickX}>
          <img src={require("@assets/img/icon_answer_x.png")} alt="" />
        </OXButton>
      </ButtonWrap>
      <FeedBack className="answer-X" />
      <FeedBack className="answer-O" />
    </Wrap>
  );
};

export default ActivityType1;
